module.exports = __webpack_public_path__ + "Roboto-Thin.cc85ce37b4256966e6f3.ttf";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-Thin.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Thin.ttf
// module chunks = 34